import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { WaveAuthProvider } from './context/WaveAuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Home from './components/Home';
import WaveAuth from './components/auth/WaveAuth';
import WaveCallback from './components/auth/WaveCallback';

function App() {
  return (
    <Router>
      <WaveAuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/wave-auth" element={<WaveAuth />} />
          <Route path="/auth/callback" element={<WaveCallback />} />
          
          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </WaveAuthProvider>
    </Router>
  );
}

export default App; 